import { useContext } from 'react';
import OptimizelyContext from './OptimizelyContext';
import getOptimizelyInstance from './getOptimizelyInstance';
const noop = () => {};
const useOptimizelyTrack = () => {
  const {
    disabled,
    user: {
      id
      // TODO: Should also we pull in `attributes` here?
    } = {}
  } = useContext(OptimizelyContext);
  if (disabled) {
    return noop;
  }
  return (eventKey, {
    userId = id,
    attributes,
    tags,
    value = tags && tags.value
  } = {}) => getOptimizelyInstance().track(eventKey, userId, attributes, {
    ...tags,
    value
  });
};
export default useOptimizelyTrack;